// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetEstimationSuburbanRequest,
  TGetEstimationSuburbanModel,
  IMappers,
  TGetEstimationSuburbanResponse,
  IGetEstimationSuburbanResponse,
  IGetEstimationSuburbanResponseError,
} from './types';

export const defaultConfig: TGetEstimationSuburbanModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'price-estimator',
  pathApi: '/v1/get-estimation-suburban/',
  requestType: 'json',
} as TGetEstimationSuburbanModel;

export function createGetEstimationSuburbanModel(
  parameters: IGetEstimationSuburbanRequest,
): TGetEstimationSuburbanModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetEstimationSuburbanOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetEstimationSuburbanRequest;
}

export async function fetchGetEstimationSuburban<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetEstimationSuburbanOptions<TResponse200, TResponse400>): Promise<
  TGetEstimationSuburbanResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetEstimationSuburbanModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetEstimationSuburbanResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetEstimationSuburbanResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetEstimationSuburbanResponse;
}
